import Navbar from './Components/Navbar';
import Homepage from './Components/Homepage';
import About from './Components/About';
import Projects from './Components/Projects';
import Clients from './Components/Clients';
import Contact from './Components/Contact';
import { ToastContainer } from 'react-toastify';



function App() {
  return (
    <div>
      <Navbar />
      <Homepage />
      <About />
      <Projects />
      <Clients />
      <Contact />
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
